import { VpSkeleton } from '@vtmn-play/react'

const ActionPlanSkeleton = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="flex flex-col gap-5 p-5">
        <VpSkeleton variantStyle="on-brand" shape="rounded" className="h-6 w-20" />
        <div className="flex flex-col gap-4 justify-center items-center">
          <div className="w-full flex flex-col gap-1 items-center">
            <VpSkeleton
              variantStyle="on-brand"
              shape="rounded"
              variant="graphic"
              className="w-[90%] h-7"
            />
            <VpSkeleton
              variantStyle="on-brand"
              shape="rounded"
              variant="graphic"
              className="w-1/2 h-6"
            />
          </div>
          <div className={`flex justify-center items-center text-white gap-2`}>
            <VpSkeleton className="h-12 w-12" variantStyle="on-brand" />
            <VpSkeleton className="h-10 w-18" shape="rounded" variantStyle="on-brand" />
          </div>
        </div>
      </div>
      <div className="bg-white flex-1 flex flex-col rounded-t-2xl p-5">
        <div className="flex flex-col gap-6">
          <div className="items-center">
            <VpSkeleton shape="rounded" className="h-7 w-48" />
          </div>
          <div className="flex flex-col gap-4">
            {Array.from({ length: 5 }, () => crypto.randomUUID()).map((key) => (
              <VpSkeleton key={key} shape="rounded" className="h-12 w-full" />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActionPlanSkeleton
